'use client'

import { usePathname } from 'next/navigation'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { formatImageURL } from '@/utils/util'
import { getInitials } from '@/utils/avatar'
import { navigateUrl } from '@/utils/client-request'

export default function BrandCard({ brand, index = 0 }: { brand: any, index?: number }) {
  const pathname = usePathname()
  const initials = getInitials(brand?.name || '')
  const count = brand?.productCount ?? 0

  return (
    <motion.a
      href={navigateUrl(`/product?brand=${brand.id}`, pathname)}
      className="group relative rounded-2xl p-6 flex flex-col cursor-pointer transition-colors hover:bg-white/5 min-h-70"
      style={{ background: 'rgba(255,255,255,0.035)', border: '1px solid rgba(255,255,255,0.07)' }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.4), duration: 0.5, ease: 'easeOut' }}
      viewport={{ once: true }}
    >
      <div className="flex items-center justify-between">
        <div className="text-[10px] font-mono tabular-nums tracking-[0.2em]" style={{ color: 'rgba(255,255,255,0.4)' }}>
          {String(index + 1).padStart(2, '0')}
        </div>
        {brand?.thumbnail ? (
          <div
            className="w-10 h-10 rounded-full overflow-hidden shrink-0"
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}
          >
            <img src={formatImageURL(brand.thumbnail)} alt={brand.name} className="w-full h-full object-cover" />
          </div>
        ) : (
          <div
            className="w-10 h-10 rounded-full inline-flex items-center justify-center text-[11px] font-bold tracking-tight shrink-0"
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
          >
            {initials}
          </div>
        )}
      </div>

      <div className="mt-9 flex-1 flex flex-col justify-center text-center">
        <h3
          className="font-semibold tracking-[-0.02em] leading-[0.95] text-white line-clamp-2"
          style={{ fontFamily: 'Gilroy, Inter, sans-serif', fontSize: 26 }}
        >
          {brand.name}
        </h3>
      </div>

      <div
        className="mt-6 pt-5 flex items-center justify-between gap-3"
        style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
      >
        <div>
          <div className="text-[15px] font-semibold tabular-nums text-white leading-none">{count}</div>
          <div className="text-[10px] uppercase tracking-[0.16em] mt-1" style={{ color: 'rgba(255,255,255,0.55)' }}>бараа</div>
        </div>
        <div
          className="w-9 h-9 rounded-full inline-flex items-center justify-center transition-all group-hover:translate-x-0.5"
          style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.07)', color: 'white' }}
        >
          <ArrowRight className="h-3.5 w-3.5" />
        </div>
      </div>
    </motion.a>
  )
}
